import * as yup from 'yup';

export function generateYupSchemaForEmail(props) {
  let rules = props.rules;

  let yupSchema = yup.string();

  // Custom methods for email validation errors
  function hasNoConsecutivePeriods(value) {
    return !/\.\./.test(value); // Returns false if consecutive periods(.) are found
  }

  function isValidEmail(message) {
    return this.test('isValidEmail', message, function (value) {
      const { path, createError } = this;

      if (!value && rules.required) {
        return createError({
          path,
          message: message ?? 'E-mail is verplicht.'
        });
      }
      if (value) {
        // Check if the email starts or ends with invalid characters (not alphanumeric)
        if (!/^[a-zA-Z0-9]/.test(value)) {
          return createError({
            path,
            message: message ?? 'Het eerste teken moet alfanumeriek zijn.'
          });
        }
        if (!/(?!.*\.$)/.test(value)) {
          return createError({
            path,
            message: message ?? 'E-mail mag niet eindigen met een punt(.)'
          });
        }
        // Check if the email ends with a valid character (alphanumeric)
        if (!/[a-zA-Z0-9]$/.test(value)) {
          return createError({
            path,
            message: message ?? 'Het laatste teken moet een letter (a-z) of cijfer (0-9) zijn.'
          });
        }
        // Check if the email contains only valid characters (letters, numbers, periods, hyphens, and underscores)
        if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
          return createError({
            path,
            message:
              message ??
              'Alleen letters (a-z), cijfers (0-9) en punten (.) koppelteken(-) onderstrepingsteken (_) zijn toegestaan.'
          });
        }
        const [localPart, domainPart] = value.split('@');
        // Check for special characters right before '@'
        if (/[^a-zA-Z0-9]$/.test(localPart)) {
          return createError({
            path,
            message: message ?? 'Ongeldig teken vlak vóór het "@"-symbool.'
          });
        }
        // Check if the domain part starts with invalid characters (like period or special characters)
        if (domainPart && (domainPart.startsWith('.') || /[^a-zA-Z0-9]/.test(domainPart[0]))) {
          return createError({
            path,
            message: message ?? 'Het domeingedeelte mag niet beginnen met een speciaal teken of punt.'
          });
        }
        // Check for consecutive periods
        if (!hasNoConsecutivePeriods(value)) {
          return createError({
            path,
            message: message ?? 'Mag geen opeenvolgende punten bevatten (.)'
          });
        }
      }

      return true;
    });
  }

  yup.addMethod(yup.mixed, 'isValidEmail', isValidEmail);

  if (rules.isEmail) {
    yupSchema = yup.mixed().isValidEmail();
  }

  return yupSchema;
}
